  <div [id]="pharmaData?.powered_name+'-'+pharmaData?.product_type_id "class="pharma-list-card mt-4 cursor-pointer" (click)="navigateToDetail()"
    *ngIf="pharmaData !== undefined && callingFrom !== 'gr' && callingFrom !== 'search-list'">
    <div class="pharma-list-box" [ngClass]="{'full': size === 'full'}">
      <img [src]="pharmaData.header_image" class="pharma-list-box-img" alt="banner"
        onerror="this.src='assets/themes/images/banner-placeholder-lg.svg'">
    </div>
    <div class="pharma-list-card-content">
    <div class="row d-flex justify-content-between m-0">
      <div class="d-flex">
        <div>
          <img [ngClass]="{'full': size === 'full'}" [src]="pharmaData.powered_by"
            class="pharma-list-content-box rounded-circle m-0 p-0 d-block" alt="powered by"
            onerror="this.src='assets/themes/icons/profilepic.svg'">
        </div>
        <div class="pl-3 content-max-width" [ngClass]="{'': size === 'full', '': size !== 'full'}">
          <span>
            <p [id]="'You-might-title-' + pharmaData?.powered_name+ '-' +pharmaData?.id" class="paragraph-bold">{{pharmaData.powered_name}}</p>
            <p class="secondary-paragraph pt-2">
              <span [id]="'You-might-followers-'+pharmaData?.no_of_members + '-' +pharmaData?.id" class="color-grey-700">
                {{pharmaData.no_of_members}}
              </span>
            </p>
            <p [id]="'You-might-total-channel-' + pharmaData?.total_channel+ '-' +pharmaData?.id" class="secondary-paragraph-bold pt-3">
              {{pharmaData.total_channel}}
            </p>
          </span>
        </div>
        </div>
        <!-- <img *ngIf="size !== 'full'" class="float-right" src='assets/themes/icons/rightarrow.svg'> -->

        <div class="col-12 col-md-2 align-self-center mt-3 mt-md-0" *ngIf="size === 'full'">
          <div class="float-md-right ml-md-0 ml-5">
            <button (click)="viewDetailButton()" class="btn-design filled h-auto medium">{{mls.languageText.edetail.key18}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [id]="'you_might_be_interested_inner_card-'+pharmaData?.powered_name" class="pharma-list-card cursor-pointer" *ngIf="callingFrom === 'gr'">
    <div class="pharma-list-card-banner">
      <img [src]="pharmaData.header_image" class="pharma-list-box-img" alt="banner"
        onerror="this.src='assets/themes/icons/banner-placeholder.svg'">
    </div>
    <div class="pharma-list-card-content text-center">
      <div class="pharma-list-center-box-gr rounded-circle mx-auto bg-white">
        <img [src]="pharmaData.powered_by" class="pharma_powered_by__img" alt="powered by"
          onerror="this.src='assets/themes/icons/profilepic.svg'">
      </div>
      <h3 [id]="'You_might_title-'+pharmaData?.powered_name" class="paragraph-bold">{{pharmaData.powered_name}}</h3>
      <span class="secondary-paragraph my-1 d-block"><span [id]="'You_might_members-'+pharmaData?.no_of_members" class="color-grey-700">{{pharmaData.no_of_members}}</span></span>
      <span  class="secondary-paragraph-bold mt-3 d-block"><span [id]="'You_might_channel-'+pharmaData?.total_channel">{{pharmaData.total_channel}}</span></span>
    </div>
  </div>
  <div class="pharma-list-card search-pharma-card cursor-pointer p-3" (click)="navigateToDetail()"
    *ngIf="pharmaData !== undefined && callingFrom === 'search-list'">
    <div>
      <div class="row">
        <div class="col-12">
          <img [src]="pharmaData.powered_by" class="rounded-circle float-left" alt="powered by"
            onerror="this.src='assets/themes/icons/profilepic.svg'" width="40" height="40"/>
          <div class="pl-5">
            <p class="secondary-paragraph-bold">{{pharmaData.powered_name}}</p>
            <p class="secondary-paragraph-bold my-1">{{pharmaData.total_channel}}
              <img class="float-right " src='assets/images/arrow-right-gray.svg' width="20">
            </p>
            <p class="secondary-paragraph-bold my-2">{{pharmaData.no_of_members}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>